// locale
export const SET_LOCALE = 'SET_LOCALE'
export const SET_APP_VERSION = 'SET_APP_VERSION'
